module.exports = __webpack_public_path__ + "8c7766945e1b76f1285485dba86f3d3a.png";